// import { createApp } from 'vue'
// import App from './App.vue'

import { createApp } from 'vue'
import App from './App.vue'
import hljs from 'highlight.js'
import 'highlight.js/styles/github.css'
import './assets/global.css'
import '@/assets/styles/pygments.css'
import './assets/themes/standard-theme.css'
import './assets/themes/dark-theme.css'
import './assets/themes/corp-bank-standard-theme.css'
import './assets/themes/corp-bank-dark-theme.css'
import './assets/themes/cyber-punk-standard-theme.css'
import './assets/themes/cyber-punk-dark-theme.css'
import { initCsrf } from './axios-config'   // uses relative /api path

// Theme initialization moved to App.vue to use backend theme_family setting

await initCsrf();

const app = createApp(App)

app.directive('highlight', {
  mounted(el) {
    const codeBlocks = el.querySelectorAll('div.codehilite pre code')

    codeBlocks.forEach((block) => {
      hljs.highlightElement(block)

      const wrapper = block.closest('.codehilite')
      if (wrapper && !wrapper.querySelector('.copy-btn')) {
        const button = document.createElement('button')
        button.className = 'copy-btn'
        button.innerText = 'Copy'

        button.onclick = () => {
          navigator.clipboard.writeText(block.innerText.trim())
          button.innerText = 'Copied!'
          setTimeout(() => {
            button.innerText = 'Copy'
          }, 1500)
        }

        wrapper.appendChild(button)
      }
    })
  },
  updated(el) {
    const codeBlocks = el.querySelectorAll('div.codehilite pre code')
    codeBlocks.forEach((block) => hljs.highlightElement(block))
  }
})

app.mount('#app')


